import EntityApi from "../Api/EntityApi";


class EntityApiService {
    constructor(jsonApi, state, settings) {
        this.entityApi = new EntityApi(jsonApi);
        this.state = state;
        this.settings = settings;

        this.type = settings.type;
        this.loadingState = this.setupState('loading', false);
        this.errorState = this.setupState('error', '');
        this.modificationTypes = settings.modificationTypes ? settings.modificationTypes : [this.type];

        this.modificationState = this.setupState('modification', -1);
        this.resultState = this.setupState('result', null); //this.state.result ? this.setupState('result', null) : null;

        this.successCallback = settings.success ? settings.success : null;
        this.errorCallback = settings.error ? settings.error : null;
        this.flavor = settings.flavor ? settings.flavor : 'short';
        this.changedAfter = settings.changedAfter ? settings.changedAfter : false;
        this.filter = settings.filter ? settings.filter : null;
        this.includeDefinition = settings.includeDefinition ? settings.includeDefinition : false;

        this.state.add(this.loadingState, false);
        this.state.add(this.errorState, '');
    }

    setupState(name, startValue) {
        const stateName = this.settings[name] ? this.settings[name] : name;
        this.state.add(stateName, startValue);
        return stateName;
    }

    list(forceAll = false) {
        if (this.state.get(this.loadingState)) {
            return;
        }
        this.state.set(this.loadingState, true);
        this.state.set(this.errorState, '');
        this.entityApi.list(this.type, this.flavor,
            (resultType, list, data) => {
                if (data.status === 'success') {
                    if (data.data.hasOwnProperty('modified')){
                        this.state.set(this.modificationState, data.data.modified);
                    }
                    if (this.resultState)
                        this.state.set(this.resultState, list);
                    if (this.successCallback)
                        this.successCallback(list);
                }
                this.state.set(this.loadingState, false);
            },
            (res) => {
                if (res.status !== 'nochange') {
                    console.log('fetch failed:' + res.message);
                    this.state.set(this.errorState, res.message);
                }
                this.state.set(this.loadingState, false);
                if (this.errorCallback)
                    this.errorCallback(res);
            },
            forceAll ? -1 : this.state.get(this.modificationState),
            this.filter,
            this.includeDefinition,
            this.modificationTypes);
    }

    get(type) {
        if (this.state.get(this.loadingState)) {
            return;
        }
        this.state.set(this.loadingState, true);
        this.state.set(this.errorState, '');
        this.entityApi.get(type, this.flavor,
            (entityType, entity, data) => {
                if (data.status === 'success') {
                    if (this.resultState)
                        this.state.set(this.resultState, entity);
                    if (this.successCallback)
                        this.successCallback(entity);
                }

                this.state.set(this.loadingState, false);
            },
            (res) => {
                console.log('fetch failed:' + res.message);
                this.state.set(this.errorState, res.message);
                this.state.set(this.loadingState, false);
                if (this.errorCallback)
                    this.errorCallback(res);
            },
            this.includeDefinition);
    }

}
export default EntityApiService;